<template>
  <v-card elevation="0" flat tile>
    <v-card-text>
      <v-row justify="space-around">
        <v-col cols="12" md="12">
          <!-- Client Settings -->
          <v-textarea
            outlined
            disabled
            v-model="clientSettings"
            :label="$t('common:settings')"
            auto-grow
          />
        </v-col>
        <v-row justify="space-around">
          <v-col cols="12" md="12">
            <v-btn
              elevation="2"
              color="primary"
              class="mr-5 v-btn--rounded"
              @click="loadConfiguration"
            >{{ $t('display/elevator:edit.labels.client-tab.load') }}
            </v-btn>
            <v-btn
              elevation="2"
              class="mr-5"
              color="primary v-btn--rounded"
              @click="resetConfiguration"
            >{{ $t('display/elevator:edit.labels.client-tab.reset') }}
            </v-btn>

            <!-- Dialog for adding an emergency phone -->
            <TwoButtonDialog
              ref="singleConfigurationAdd"
              :add-text-field="true"
              :add-text-field-label="$t('display/elevator:edit.labels.client-tab.single-configuration')"
              :btn-text="$t('dialog:add-btn-text', {name : $t('display/elevator:edit.labels.client-tab.add-single-configuration')})"
              color="primary"
              :dialog-title="$t('dialog:add-btn-title', {name : $t('display/elevator:edit.labels.client-tab.single-configuration')})"
              :button1-text="$t('buttons:add')"
              :button2-text="$t('buttons:cancel')"
              @clickedButton1="addConfiguration"
              @clickedButton2="$refs.singleConfigurationAdd.showDialog = false"
            />
          </v-col>
        </v-row>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import ElevatorService from '@/modules/display/services/elevator-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "ClientConfigurationTab",
  components: {
    TwoButtonDialog
  },
  data() {
    return {
      clientSettings: null
    }
  },
  methods: {
    addConfiguration() {
      let configArr = this.$refs.singleConfigurationAdd.textField.split('=');
      let configForm = this.$refs.singleConfigurationAdd;

      if (configArr.length > 1) {
        let configuration = {
          "key": configArr[0],
          "value": configArr[1]
        }

        ElevatorService.singleClientConfiguration(
          this.$store.state.display.elevatorForm.elevator.id,
          configuration,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('display/elevator:edit.snackbar.single-configuration')}));
            configForm.showDialog = false;

          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/elevator:edit.snackbar.single-configuration')}));
            configForm.showDialog = false;
          }
        );
      } else {
        Utils.showFailureSnackbar(this.$t('display/elevator:edit.snackbar.incorrect-key-value'));
        configForm.showDialog = false;

      }
    },
    resetConfiguration() {
      ElevatorService.resetClientConfiguration(
        this.$store.state.display.elevatorForm.elevator.id,
        (response) => {
          this.clientSettings = '';
          if (response.data.noConfig != null) {
            this.clientSettings = response.data.noConfig;
          }
        }
      );

    },
    loadConfiguration() {
      ElevatorService.loadClientConfiguration(
        this.$store.state.display.elevatorForm.elevator.id,
        (response) => {
          this.clientSettings = '';
          if (response.data.noConfig != null) {
            this.clientSettings = response.data.noConfig;
          } else {
            for (let attr in response.data) {
              this.clientSettings += attr + '=' + response.data[attr] + "\n";
            }
          }

        }
      );
    }
  }
}
</script>

<style scoped>

</style>